import { TYPE_CELLS } from "@lhd/components/CloneApp/pages/SheetApp/contants";
import { NumberCellTemplate } from "@lhd/components/CloneApp/pages/SheetApp/cells/NumberCellTemplate";
import { TimeCellTemplate } from "@lhd/components/CloneApp/pages/SheetApp/cells/TimeCellTemplate";
import { DateTimeCellTemplate } from "@lhd/components/CloneApp/pages/SheetApp/cells/DateTimeCellTemplate";
import { DateCellTemplate } from "@lhd/components/CloneApp/pages/SheetApp/cells/DateCellTemplate";
import { RichTextCellTemplate } from "@lhd/components/CloneApp/pages/SheetApp/cells/RichTextCellTemplate";
import { SelectCellTemplate } from "@lhd/components/CloneApp/pages/SheetApp/cells/SelectCellTemplate";
import { RadioCellTemplate } from "@lhd/components/CloneApp/pages/SheetApp/cells/RadioCellTemplate";
import { MultiChoiceCellTemplate } from "@lhd/components/CloneApp/pages/SheetApp/cells/MultiChoiceCellTemplate";
import { CheckBoxCellTemplate } from "@lhd/components/CloneApp/pages/SheetApp/cells/CheckBoxCellTemplate";
import { DropDownCellTemplate } from "@lhd/components/CloneApp/pages/SheetApp/cells/DropDownCellTemplate";
import { LinkCellTemplate } from "@lhd/components/CloneApp/pages/SheetApp/cells/LinkCellTemplate";
import { AttachmentCellTemplate } from "@lhd/components/CloneApp/pages/SheetApp/cells/AttachmentCellTemplate";
import { TextAreaCellTemplate } from "../../pages/SheetApp/cells/TextAreaCellTemplate";
import { TextCellTemplate } from "../../pages/SheetApp/cells/TextCellTemplate";

export const CUSTOM_CELL_TEMPLATES = {
  [TYPE_CELLS.NUMBER_CELL]: new NumberCellTemplate(),
  [TYPE_CELLS.TIME_CELL]: new TimeCellTemplate(),
  [TYPE_CELLS.DATE_TIME_CELL]: new DateTimeCellTemplate(),
  [TYPE_CELLS.DATE_CELL]: new DateCellTemplate(),
  [TYPE_CELLS.SELECT_CELL]: new SelectCellTemplate(),
  [TYPE_CELLS.RICH_TEXT_CELL]: new RichTextCellTemplate(),
  [TYPE_CELLS.RADIO_CELL]: new RadioCellTemplate(),
  [TYPE_CELLS.CHECK_BOX_CELL]: new CheckBoxCellTemplate(),
  [TYPE_CELLS.MULTI_CHOICE_CELL]: new MultiChoiceCellTemplate(),
  [TYPE_CELLS.DROP_DOWN_CELL]: new DropDownCellTemplate(),
  [TYPE_CELLS.LINK_CELL]: new LinkCellTemplate(),
  [TYPE_CELLS.ATTACHMENT_CELL]: new AttachmentCellTemplate(),
  [TYPE_CELLS.TEXT_AREA_CELL]: new TextAreaCellTemplate(),
  [TYPE_CELLS.TEXT_CELL]: new TextCellTemplate(),
};
